/**
 * StepTest — step 5 of the agent-creation flow: try the agent.
 *
 * The real Playground (ChatModal, embedded) against the real agent — the same
 * component the Wix / WordPress onboardings and the Overview use. While pages
 * are still being learned in the background the subtitle says so; testing is
 * possible anyway. The "Talk to a human" pill opens the live-chat info modal
 * (same as in the Design preview).
 */
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faXmark } from '@fortawesome/free-solid-svg-icons';
import ChatModal from '../../../components/chatModal.js';
import StepFooter from './StepFooter.js';
import './StepTest.css';

export default function StepTest({ agent, botId, goNext, goBack, strips, training, primaryLabel, busy = false, chatAppearance }) {
  const { t } = useTranslation();
  const [liveOpen, setLiveOpen] = useState(false);

  return (
    <>
      <header className="ac-head">
        <h2 className="ac-title">{t('ac_test_title', { name: agent?.name || '' })}</h2>
        <p className="ac-sub">{training ? t('ac_test_sub_training') : t('ac_test_sub')}</p>
      </header>

      <div className="ac-body ac-body-test">
        <div className="ac-test-chat">
          <ChatModal
            embedded
            appearance={chatAppearance}
            displayName={agent?.name}
            open
            onClose={() => {}}
            bot={{ id: botId, knowledge_count: 1 }}
            currentMessageCount={0}
            messagePlanLimit={999999}
            planName="trial"
            openSubscriptionModalFromChat={() => {}}
            onMessageCountChange={() => {}}
            liveCtaAlways
            onLiveCta={() => setLiveOpen(true)}
            // Meeting the agent, not tuning it: the "Improve this answer" CTA stays a portal surface.
            showImprove={false}
          />
        </div>
        {strips}
      </div>

      <StepFooter onBack={goBack} primaryLabel={primaryLabel || t('ac_test_cta')} onPrimary={goNext} busy={busy} />

      {liveOpen && createPortal(
        <div className="ac-live-overlay" onClick={() => setLiveOpen(false)}>
          <div className="ac-live-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="ac-live-grid" aria-hidden="true" />
            <button type="button" className="ac-live-close" onClick={() => setLiveOpen(false)} aria-label={t('close')}><FontAwesomeIcon icon={faXmark} /></button>
            <div className="ac-live-inner">
              <span className="ac-live-icon"><FontAwesomeIcon icon={faHeadset} /></span>
              <h3 className="ac-live-title">{t('wxo_live_modal_title')}</h3>
              <p className="ac-live-body">{t('wxo_live_modal_body')}</p>
              <button type="button" className="ac-live-ok" onClick={() => setLiveOpen(false)}>{t('wxo_live_modal_ok')}</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
